export default {
  commonPapersize: 'Gängige Papiergrößen',
  customerPapersize: 'Kundenspezifische Papiergröße',
};
